export const CONSTANT = Object.freeze({
  USER_NAME_MAX_LENGTH: 60,
  UPLOAD_TOTAL_LIMIT_BYTES: 1024 * 1024 * 1024 * 1000, // 1000GB
  UPLOAD_SINGLE_LIMIT_BYTES: 1024 * 1024 * 1024 * 250 // 250GB
})

export const SHARING_STATE = Object.freeze({
  FILE_REQUEST_PASSWORD: 'file_request_password',
  FILE_REQEUST_EXPIRED: 'file_request_expired',
  FILE_REQUEST_CLOSED: 'file_request_closed',
  FILE_REQUEST_ERROR: 'file_request_invalid',
  FILE_REQUEST_OK: 'file_request_ok',
})

export const AUTH_STATUS = Object.freeze({
  WAITING: 0,
  AUTHENTICATING: 1,
  ERROR: 2,
  DONE: 3,
})

export const UploadIdentifier = Object.freeze({
  CREATE_FOLDER: 'create_folder',
  ADD_PREFIX: 'add_prefix',
})

export const UploadStatus = Object.freeze({
  IDLE: 'idle',
  SELECTED: 'selected',
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded'
})

export const UploadItemStatus = Object.freeze({
  IDLE: 'idle',
  SIZE_EXCEED: 'size_exceed',
  UPLOADING: 'uploading',
  WAITING: 'waiting',
  SUCCESS: 'success',
  FAILED: 'failed',
  PARTIAL_FAILED: 'partial_failed', // for folder
})
